import React from 'react'
import { Line } from 'react-chartjs-2';


function LineChart(props) {

    let labels = []
    let values = []

    if (props.data) {
        props.data.length && props.data.forEach(element => {
            labels.push(element.Week)
            values.push(element.Total)
        });
    }

    const data = {
        labels: labels.reverse(),
        datasets: [
            {
                label: 'No. of shipments',
                data: values.reverse(),
                fill: false,
                backgroundColor: `rgba(10, 45, 68)`,
                borderColor: `rgba(0, 185, 181)`,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                    gridLines: {
                        drawOnChartArea: false
                    }
                },
            ],
            xAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                    gridLines: {
                        drawOnChartArea: false
                    }
                },
            ]
        },
    };

    return (
        <Line data={data} options={options} />
    )
}

export default React.memo(LineChart)
